<template>
  <section class="account">
    <div class="container">
      <h1 class="title">Edit Account</h1>
      <div class="row">
        <div class="col">
          <loading v-if="loading" class="white-bg shadow-card" />
          <div
            class="card shadow-card"
            data-v-step="clientAccountContainer"
            v-if="!loading && user"
          >
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <div class="form-group">
                    <label>First Name</label>
                    <input
                      type="text"
                      v-model="user.first"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="col">
                  <div class="form-group">
                    <label>Last Name</label>
                    <input
                      type="text"
                      v-model="user.last"
                      class="form-control"
                    />
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label>Email</label>
                <input type="email" v-model="user.email" class="form-control" />
              </div>
              <div class="form-group">
                <label>Password</label>
                <input
                  type="password"
                  v-model="user.password"
                  class="form-control"
                />
              </div>
              <div class="form-group">
                <label>Phone Number</label>
                <input
                  type="text"
                  :key="user.email"
                  v-model="user.phone"
                  v-cleave="cleave.phone"
                  class="form-control"
                  minlength="10"
                />
              </div>
              <div class="form-group">
                <label>Occupation</label>
                <select
                  id="occupation"
                  :disabled="loading"
                  v-model="user.occupation_id"
                  class="form-control"
                  placeholder="Occupation"
                >
                  <option :value="null">Select An Occupation</option>
                  <option
                    :value="o.id"
                    v-for="o in occupations.data"
                    :key="o.id"
                  >
                    {{ o.name }}
                  </option>
                </select>
              </div>
              <div class="form-group">
                <label>Receive Notifications Via</label>
                <div class="d-flex mb-5">
                  <div class="custom-control custom-switch ml-3 mr-5">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="sendingSMS"
                      v-model="user.enable_sending_sms"
                    />
                    <label
                      class="custom-control-label cursor-pointer"
                      for="sendingSMS"
                      >SMS</label
                    >
                  </div>
                  <div class="custom-control custom-switch ml-5">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="sendingEmail"
                      v-model="user.enable_sending_email"
                    />
                    <label
                      class="custom-control-label cursor-pointer"
                      for="sendingEmail"
                      >Email</label
                    >
                  </div>
                </div>
              </div>
              <div class="d-flex align-items-center justify-content-center">
                <button
                  @click="updateUser"
                  :disabled="saving"
                  class="btn btn-primary btn-block btn-300"
                >
                  <span v-if="!saving">Update User</span>
                  <span
                    class="spinner-border spinner-border-sm"
                    v-if="saving"
                    role="status"
                    aria-hidden="true"
                  ></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapState } from "vuex";
import Auth from "@/auth";
import Swal from "sweetalert2";

export default {
  name: "Account",
  data() {
    return {
      cleave: {
        phone: { blocks: [3, 3, 4], delimiter: "-", numericOnly: true },
      },
    };
  },
  computed: {
    ...mapState(["saving", "loading", "users", "occupations"]),
    userData: function () {
      return Auth.user.get();
    },
    id: function () {
      return this.userData.id;
    },
    user: function () {
      return this.users.user;
    },
  },
  mounted() {
    this.$store.commit("SET_LOADING_STATE", true, { root: true });
    this.$store.dispatch("occupations/all");
    this.$store.dispatch("users/get", this.id);
  },
  methods: {
    updateUser: function () {
      if (this.user.phone.length < 12) {
        return Swal.fire({
          title: "Validation Errors",
          text: "The phone must be at least 10 digits.",
          type: "error",
        });
      }
      this.$store.commit("SET_SAVING_STATE", true, { root: true });
      this.$store.dispatch("users/updateAccount", {
        id: this.id,
        data: this.user,
      });
    },
  },
};
</script>
